import { instance } from "../axios"
import type { AxiosRequestConfig } from "axios"

// 取得預覽與寄件人管理設定
export function getSendingConfiguration(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/systems/sending-configuration/",
        method: "get",
        ...config,
    })
}

// 更新預覽與寄件人管理設定
export function updateSendingConfiguration(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/systems/sending-configuration/",
        method: "put",
        ...config,
    })
}
